import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const handmadeMontessoriToys: BlogMetaData = {
  title: 'モンテッソーリ手作りおもちゃ・教具ガイド｜年齢別（0歳〜3歳）ねらいと作り方',
  description:
    'モンテッソーリの手作りおもちゃ・教具を0歳・1歳・2歳・3歳の年齢別に紹介。敏感期のねらい、100均材料で作れる具体的な作り方と活用ポイントを、モンテ歴20年以上のプロが解説します。',
  thumbnailUrl: '/img/blog-handmade-montessori-toys.webp',
  filePath: buildBlogFilePath('handmade-montessori-toys'),
  category: BLOG_CATEGORY.PLAY_TOOLS,
};
